<template>
  <div class="llm-width" ref="containerRef">
    <a-affix :target="() => containerRef">
      <a-button type="primary">Affix top</a-button>
    </a-affix>
    <div style="padding: 20px">
      <lins-card
              title="Background"
              content="The biomedical field is experiencing a significant expansion in data growth as novel technologies develop, propelled by the vast amounts of medical texts, images, and omics data being collected. Analyzing this data requires complex computational methods that integrates skills from bioinformatics, artificial intelligence, software programming, statistics and mathematics. Various tools and platforms, such as Galaxy and Seven Bridges, provide interfaces for workflow creation and execution, but they face challenges, including reliance on predefined workflows, insufficient support for natural language instructions and lack of summarized readable reports, which restricts intuitive user engagement. Large Language Models (LLMs) have show great advantage in natural language comprehension and demonstrated potential in biomedical data analyses, yet they encounter significant challenges with complex problem planning and low success rate of execution.
Addressing these challenges, we introduce BioMedAgent, an autonomous framework that capitalizes on LLM-powered multi-agents with self-evolving capabilities, incorporating Interactive Exploration (IE) and Memory Retrieval (MR) algorithms. BioMedAgent supports natural language-based task initiation, allowing direct participation from biomedical professionals with no specialized computational or bioinformatics training.
BioMedAgent was tested using the BioMed-AQA bench, comprising 327 manually curated bioinformatic analyses questions across five categories: omics analyses (O), precision medicine support analyses (P), machine learning (M), statistical analyses (S), and data visualization (V). Through the collaborative planning, coding, and execution of multiple agents, it achieved an average success rate of 77%, outperforming two OpenAI web agent applications and a local agent application, each also based on the GPT-4omini LLM. Remarkably, it even surpassed the performance of ChatGPT-4o application using the bigger model, which had a 47% success rate (Figure 1)."
      />
      <div style="text-align: center; margin-bottom: 15px">
          <img :src="require('@/assets/figure1.png')" alt="" width="50%">
          <img :src="require('@/assets/figure2.png')" alt="" width="50%">
      </div>
      <lins-card title="Highlights">
        <template #content>
          <p>We propose BioMedAgent, an autonomous biomedical data analyses framework that firstly utilizes LLM-powered multi-agents with self-evolving capabilities.
          </p>
          <div>
            <p>
              • We built the first comprehensive benchmark for evaluating LLM applications in biomedical analyses, BioMed-AQA, spanning five categories of tasks, with natural language questions as analyses instructions and manually annotated answers.
            </p>
            <p>
              • Extensive experiments demonstrate that BioMedAgent outperforms existing OpenAI agent applications, demonstrating higher success rates across diverse biomedical analyses tasks.
            </p>
            <p>
              • BioMedAgent supports natural language-based task initiation, allowing direct participation from biomedical professionals with no specialized computational or bioinformatics training
            </p>
          </div>
        </template>
      </lins-card>
    </div>
  </div>
  <a-affix :offset-bottom="-15" @change="change">
        <p style="text-align: center;background: #F5F5F5;padding: 20px">
          More information could be found at <a href="https://drai.cn/">drai.cn</a>.
        </p>
  </a-affix>
</template>




<script>
  import {ref} from 'vue';
  import LinsCard from "../components/BioCard";
  export default {
    name: "LinsHome",
    components: {
      LinsCard,
    },
    setup() {
      const containerRef = ref(null);
      return {
        containerRef,
      };
    },
    data(){
      return {

      }
    },
  }
</script>

<style scoped>


</style>